import UseAxios from './http/http';

const makeApiCall = async request => {
  const data = await UseAxios(request);
  console.log(data);

  return data;
};

export default makeApiCall;
